export const TIME_DIFFICULTY_CURVE = {
  fastRampStartSeconds: 30,
  earlyDifficultyPerSecond: 0.012,
  lateDifficultyPerSecond: 0.038,
  earlySpeedPerSecond: 2.6,
  lateSpeedPerSecond: 6.8,
  earlyEnemyPerSecond: 0.003,
  lateEnemyPerSecond: 0.012,
  earlyGapPerSecond: 0.9,
  lateGapPerSecond: 2.6,
  earlyPlatformShrinkPerSecond: 0.55,
  latePlatformShrinkPerSecond: 1.45,
  earlyVerticalPerSecond: 0.5,
  lateVerticalPerSecond: 1.55,
  maxDifficultyBonus: 1.15,
  maxSpeedBonus: 245,
  maxEnemyBonus: 0.38,
  maxGapBonus: 120,
  maxPlatformShrink: 74,
  maxVerticalBonus: 74,
};
